export const iconFontAwesomeMapsLeaf = (
	<i className="fa-solid fa-leaf"></i>
);
